export const ADD_TO_WATCH_LIST = 'innovA/watchList#addToWatchList';
export const REMOVE_FROM_WATCH_LIST = 'innovA/watchList#removeFromWatchList';
export const GET_WATCHLIST = 'innovA/wathclist#getWatchlist';
export const LOADING_WATCHLIST = 'innovA/watchlist#loadingWatchList';
